module.exports = __webpack_public_path__ + "img/result-detail-output-outleft02.713de424.svg";